import { LockOutlined } from "@ant-design/icons";
import { Button, Card, Form, Input, Typography, message } from "antd";
import { useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./Login.css";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { confirmPasswordReset } = useAuth();

  const uid = searchParams.get("uid");
  const token = searchParams.get("token");

  const hasValidParams = useMemo(() => Boolean(uid && token), [uid, token]);

  const handleSubmit = async (values) => {
    if (!hasValidParams) return;
    try {
      setIsLoading(true);
      await confirmPasswordReset({
        uid,
        token,
        new_password: values.password,
      });
      setIsSuccess(true);
      messageApi.success("Senha redefinida com sucesso.");
      form.resetFields();
    } catch (error) {
      console.error(error);
      messageApi.error(
        "Link inválido ou expirado. Solicite uma nova redefinição."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      {contextHolder}
      <video
        className="login-bg-video"
        autoPlay
        muted
        loop
        playsInline
        preload="auto">
        <source src="/videos/ouran-login-bg.mp4" type="video/mp4" />
      </video>
      <div className="login-bg-overlay" />

      <div
        className="login-content"
        style={{ display: "grid", placeItems: "center" }}>
        <Card className="login-card" bordered={false}>
          <Typography.Title level={4} className="login-title">
            Redefinir senha
          </Typography.Title>
          <Typography.Paragraph className="login-subtitle">
            Crie uma nova senha para seu acesso ao Ouran.
          </Typography.Paragraph>

          {!hasValidParams ? (
            <>
              <Typography.Paragraph type="danger">
                O link de redefinição está incompleto ou inválido.
              </Typography.Paragraph>
              <Button type="primary" block>
                <Link to="/login">Voltar para login</Link>
              </Button>
            </>
          ) : isSuccess ? (
            <>
              <Typography.Paragraph>
                Senha redefinida com sucesso. Você já pode entrar com a nova
                senha.
              </Typography.Paragraph>
              <Button type="primary" block>
                <Link to="/login">Ir para login</Link>
              </Button>
            </>
          ) : (
            <Form
              form={form}
              layout="vertical"
              requiredMark={false}
              onFinish={handleSubmit}
              autoComplete="on">
              <Form.Item
                label="Nova senha"
                name="password"
                rules={[
                  { required: true, message: "Informe a nova senha." },
                  { min: 8, message: "Use ao menos 8 caracteres." },
                ]}>
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Digite sua nova senha"
                  autoComplete="new-password"
                />
              </Form.Item>
              <Form.Item
                label="Confirmar nova senha"
                name="confirm_password"
                dependencies={["password"]}
                rules={[
                  { required: true, message: "Confirme sua nova senha." },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("As senhas não conferem.")
                      );
                    },
                  }),
                ]}>
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Repita a nova senha"
                  autoComplete="new-password"
                />
              </Form.Item>

              <Button
                htmlType="submit"
                type="primary"
                className="login-submit-btn"
                loading={isLoading}>
                Salvar nova senha
              </Button>
              <Button style={{ marginTop: 10 }} block>
                <Link to="/login">Cancelar</Link>
              </Button>
            </Form>
          )}
        </Card>
      </div>
    </div>
  );
}
